import { scan } from 'react-scan'
import 'bootstrap/dist/css/bootstrap.min.css'
import 't4b-core-frontend/lib/index.css'
import 'overlayscrollbars/css/OverlayScrollbars.css'
import './index.scss'
import 'react-datepicker/dist/react-datepicker.css'
import 'moment-timezone'
import 'react-toastify/dist/ReactToastify.css'
import React from 'react'
import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import { App } from './App'
import { store } from './store'
import { ErrorBoundary } from './components/ErrorBoundary/ErrorBoundary'

scan({
    enabled: true
})

if (!Array.prototype.toSpliced) {
    Array.prototype.toSpliced = function (start, deleteCount, ...items) {
        return [...this.slice(0, start), ...items, ...this.slice(start + (deleteCount ?? 0))];
    };
}

const container = document.getElementById('root')

if (!container) {
    throw new Error('There is no root element')
}

const root = ReactDOM.createRoot(container)

root.render(
    <React.StrictMode>
        <BrowserRouter>
            <ErrorBoundary>
                <Provider store={store}>
                    <App />
                </Provider>
            </ErrorBoundary>
        </BrowserRouter>
    </React.StrictMode>,
)
